import { render, staticRenderFns } from "./ReviewProblemList.vue?vue&type=template&id=4b620363&scoped=true&lang=pug&"
import script from "./ReviewProblemList.vue?vue&type=script&lang=ts&"
export * from "./ReviewProblemList.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewProblemList.vue?vue&type=style&index=0&id=4b620363&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b620363",
  null
  
)

export default component.exports